import type { MovieOfTheNightTvShow } from '@bldsoft/cappie/api/wbs'
import type { MotnSeries } from '@setplex/tria-api'

import * as v from 'valibot'
import {
  getMotnBackgroundImage,
  getMotnHorizontalImage,
  getMotnMobileBackgroundImage,
  getMotnVerticalImage,
} from '../../utils/images'
import { MotnStreamingOptionSchema } from './motn-streaming.schema'

export const MotnTvShowSchema = v.pipe(
  v.object({
    name: v.nullish(v.string()),
    contentType: v.picklist(['MOTN_TV_SHOW']),
    description: v.nullish(v.string()),
    directors: v.nullish(v.string()),
    stars: v.nullish(v.string()),
    year: v.nullish(v.number()),
    imageUrlw240: v.nullish(v.string()),
    imageUrlw360: v.nullish(v.string()),
    imageUrlw480: v.nullish(v.string()),
    imageUrlw600: v.nullish(v.string()),
    imageUrlw720: v.nullish(v.string()),
    imageBackgroundUrlw360: v.nullish(v.string()),
    imageBackgroundUrlw480: v.nullish(v.string()),
    imageBackgroundUrlw720: v.nullish(v.string()),
    imageBackgroundUrlw1080: v.nullish(v.string()),
    imageBackgroundUrlw1440: v.nullish(v.string()),
    imageHorizontalUrlw360: v.nullish(v.string()),
    imageHorizontalUrlw480: v.nullish(v.string()),
    imageHorizontalUrlw720: v.nullish(v.string()),
    imageHorizontalUrlw1080: v.nullish(v.string()),
    imageHorizontalUrlw1440: v.nullish(v.string()),
    seasonCount: v.nullish(v.number()),
    episodeCount: v.nullish(v.number()),
    streamingOptions: v.nullish(v.array(MotnStreamingOptionSchema)),
  }),
  v.transform(
    ({
      imageUrlw240,
      imageUrlw360,
      imageUrlw480,
      imageUrlw600,
      imageUrlw720,
      imageBackgroundUrlw360,
      imageBackgroundUrlw480,
      imageBackgroundUrlw720,
      imageBackgroundUrlw1080,
      imageBackgroundUrlw1440,
      imageHorizontalUrlw360,
      imageHorizontalUrlw480,
      imageHorizontalUrlw720,
      imageHorizontalUrlw1080,
      imageHorizontalUrlw1440,
      name,
      description,
      year,
      seasonCount,
      episodeCount,
      directors,
      stars,
      contentType,
      streamingOptions,
    }) => ({
      contentType,
      name: name ?? undefined,
      description: description ?? undefined,
      year: year ?? undefined,
      seasonCount: seasonCount ?? undefined,
      episodeCount: episodeCount ?? undefined,
      directors,
      stars,
      streamingOptions: streamingOptions ?? undefined,
      imageUrl: getMotnVerticalImage({
        w240: imageUrlw240 ?? undefined,
        w360: imageUrlw360 ?? undefined,
        w480: imageUrlw480 ?? undefined,
        w600: imageUrlw600 ?? undefined,
        w720: imageUrlw720 ?? undefined,
      }),
      imageBackgroundUrl: getMotnBackgroundImage({
        w360: imageBackgroundUrlw360 ?? undefined,
        w480: imageBackgroundUrlw480 ?? undefined,
        w720: imageBackgroundUrlw720 ?? undefined,
        w1080: imageBackgroundUrlw1080 ?? undefined,
        w1440: imageBackgroundUrlw1440 ?? undefined,
      }),
      imageHorizontalUrl: getMotnHorizontalImage({
        w360: imageHorizontalUrlw360 ?? undefined,
        w480: imageHorizontalUrlw480 ?? undefined,
        w720: imageHorizontalUrlw720 ?? undefined,
        w1080: imageHorizontalUrlw1080 ?? undefined,
        w1440: imageHorizontalUrlw1440 ?? undefined,
      }),
      imageMobileBackgroundUrl: getMotnMobileBackgroundImage({
        w240: imageUrlw240 ?? undefined,
        w360: imageUrlw360 ?? undefined,
        w480: imageUrlw480 ?? undefined,
        w600: imageUrlw600 ?? undefined,
        w720: imageUrlw720 ?? undefined,
      }),
    })
  )
)

export const formatMotnTvShow = (raw: MovieOfTheNightTvShow): MotnSeries =>
  v.parse(MotnTvShowSchema, raw)
